import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Ng9RutService {

  constructor() { }
}
